<template>
    <div class="wrapper flex flex-direction" v-loading="loading">
<!--        <div class="page-title_white">职业化赋能系统1.0 - 会员管理场景</div>-->
        <div class="page-title_white">首页</div>
        <div class="flex margin-top-xs">
            <div class="total-container flex-shrink">
                <div class="classify-title">会员统计</div>
                <div class="flex flex-wrap justify-between">
                    <div class="user-total_item flex align-center justify-between">
                        <div class="label">会员数量</div>
                        <div class="number">{{ user_total.usersCountAll }}</div>
                        <img class="bg" :src="require('@/assets/img/total/bg_water_ripple.png')"/>
                    </div>
                    <div class="user-total_item blue flex align-center justify-between">
                        <div class="label">单位会员</div>
                        <div class="number">{{ user_total.companyUsersCount }}</div>
                        <img class="bg" :src="require('@/assets/img/total/bg_water_ripple.png')"/>
                    </div>
                    <div class="user-total_item green flex align-center justify-between">
                        <div class="label">个人会员</div>
                        <div class="number">{{ user_total.personalUsersCount }}</div>
                        <img class="bg" :src="require('@/assets/img/total/bg_water_ripple.png')"/>
                    </div>
                    <div class="user-total_item dark-blue flex align-center justify-between">
                        <div class="label">分会数量</div>
                        <div class="number">{{ user_total.usersFHAll }}</div>
                        <img class="bg" :src="require('@/assets/img/total/bg_water_ripple.png')"/>
                    </div>
                </div>
                <div class="classify-title margin-tb-xs">职务统计</div>
                <div class="job-container flex align-center">
                    <div class="job-total_item flex-sub flex flex-direction align-center"
                         v-for="(item,index) in job_total" :key="index">
                        <div class="number" :class="index | color">{{ item.count }}</div>
                        <div class="label">{{ item.name }}</div>
                    </div>
                </div>
                <div class="classify-title margin-top">费用统计</div>
                <div class="flex flex-wrap justify-between">
                    <div class="cost-total_item flex align-center justify-between">
                        <div class="label">会费合计/元</div>
                        <div class="number">{{ const_total.allCost | formatPrice }}</div>
                    </div>
                    <div class="cost-total_item blue flex align-center justify-between">
                        <div class="label">本月/元</div>
                        <div class="number">{{ const_total.benYuePayCost | formatPrice }}</div>
                    </div>
                    <div class="cost-total_item green flex align-center justify-between">
                        <div class="label">已缴纳/元</div>
                        <div class="number">{{ const_total.payCost| formatPrice }}</div>
                    </div>
                    <div class="cost-total_item dark-blue flex align-center justify-between">
                        <div class="label">未缴纳/元</div>
                        <div class="number">{{ const_total.unpayCost | formatPrice }}</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-direction flex-sub margin-left-xs">
                <div class="service-total-container flex align-center">
                    <div class="service-total_item flex flex-direction flex-sub justify-center align-center">
                        <div class="title">受益人数</div>
                        <div class="number">{{ service_total.benefitPeopleNum }}</div>
                        <div class="flex align-center">
                            <div class="up-tag">今日新增</div>
                            <div class="up-number margin-left-xs">{{ service_total.todayBenefitPeopleNum }}</div>
                        </div>
                    </div>
                    <div class="service-total_item flex flex-direction flex-sub justify-center align-center">
                        <div class="title">服务人数</div>
                        <div class="number">{{ service_total.servicePeopleNum }}</div>
                        <div class="flex align-center">
                            <div class="up-tag">今日新增</div>
                            <div class="up-number margin-left-xs">{{ service_total.todayServicePeopleNum }}</div>
                        </div>
                    </div>
                </div>
                <div class="service-container flex-sub margin-top-xs">
                    <div class="classify-title">暖心服务</div>
                    <div  class="service_item flex flex-direction">
                        <div class="flex align-center justify-between">
                            <div class="flex align-center">
                                <img class="icon" :src="require('@/assets/img/total/icon_service_classify_1.png')"/>
                                <div class="title">会费到期</div>
                            </div>
                            <el-button class="operate" :disabled="!service_list.usersRenew.length" @click="toHeartService(1)">
                                提醒
                            </el-button>
                        </div>
                        <div class="swiper-content-container margin-top-xs" v-if="service_list.usersRenew.length">
                            <div class="swiper-button-prev swiper-button-prev1"></div>
                            <swiper
                                ref="swiper1"
                                :options="swiperOption1"
                                :pagination="{ clickable: true }"
                                navigation>
                                <swiper-slide v-for="(item,index) in service_list.usersRenew" :key="index">
                                    <div class="name" @click="toMemberDetail(item)">
                                        {{ item.name }}
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-button-next swiper-button-next1"></div>
                        </div>
                        <div class="no-data margin-top-xs flex align-center justify-center" v-else>本周无会员到期</div>
                    </div>
                    <div class="service_item flex flex-direction">
                        <div class="flex align-center justify-between">
                            <div class="flex align-center">
                                <img class="icon" :src="require('@/assets/img/total/icon_service_classify_2.png')"/>
                                <div class="title">答谢参与</div>
                            </div>
                            <el-button class="operate green" :disabled="!service_list.thanksJoin.length" @click="toHeartService(2)">
                                答谢
                            </el-button>
                        </div>
                        <div class="swiper-content-container margin-top-xs" v-if="service_list.thanksJoin.length">
                            <div class="swiper-button-prev swiper-button-prev2"></div>
                            <swiper
                                ref="swiper1"
                                :options="swiperOption2"
                                :pagination="{ clickable: true }"
                                navigation>
                                <swiper-slide v-for="(item,index) in service_list.thanksJoin" :key="index">
                                    <div class="name" @click="toMemberDetail(item)">
                                        {{ item.name }}
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-button-next swiper-button-next2"></div>
                        </div>
                        <div class="no-data margin-top-xs flex align-center justify-center" v-else>本周无会员参与活动</div>
                    </div>
                    <div class="service_item flex flex-direction">
                        <div class="flex align-center justify-between">
                            <div class="flex align-center">
                                <img class="icon" :src="require('@/assets/img/total/icon_service_classify_3.png')"/>
                                <div class="title">祝贺入会</div>
                            </div>
                            <el-button class="operate blue" :disabled="!service_list.zhuHeRuHui.length" @click="toHeartService(3)">
                                祝贺
                            </el-button>
                        </div>

                        <div class="swiper-content-container margin-top-xs" v-if="service_list.zhuHeRuHui.length">
                            <div class="swiper-button-prev swiper-button-prev3"></div>
                            <swiper
                                ref="swiper1"
                                :options="swiperOption3"
                                :pagination="{ clickable: true }"
                                navigation>
                                <swiper-slide v-for="(item,index) in service_list.zhuHeRuHui" :key="index">
                                    <div class="name" @click="toMemberDetail(item)">
                                        {{ item.name }}
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-button-next swiper-button-next3"></div>
                        </div>
                        <div class="no-data margin-top-xs flex align-center justify-center" v-else>本周无新会员入会</div>
                    </div>
                    <div class="service_item flex flex-direction">
                        <div class="flex align-center justify-between">
                            <div class="flex align-center">
                                <img class="icon" :src="require('@/assets/img/total/icon_service_classify_4.png')"/>
                                <div class="title">待审批</div>
                            </div>
                            <el-button class="operate dark-blue" :disabled="!service_list.usersCheck.length" @click="toHeartService(4)">
                                审批
                            </el-button>
                        </div>
                        <div class="swiper-content-container margin-top-xs" v-if="service_list.usersCheck.length">
                            <div class="swiper-button-prev swiper-button-prev4"></div>
                            <swiper
                                ref="swiper1"
                                :options="swiperOption4"
                                :pagination="{ clickable: true }"
                                navigation>
                                <swiper-slide v-for="(item,index) in service_list.usersCheck" :key="index">
                                    <div class="name" @click="toMemberDetail(item)">
                                        {{ item.name }}
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-button-next swiper-button-next4"></div>
                        </div>
                        <div class="no-data margin-top-xs flex align-center justify-center" v-else>本周无待审核会员</div>
                    </div>
                    <div class="service_item flex flex-direction">
                        <div class="flex align-center justify-between">
                            <div class="flex align-center">
                                <img class="icon" :src="require('@/assets/img/total/icon_service_classify_5.png')"/>
                                <div class="title">生日提醒</div>
                            </div>
                            <el-button class="operate purple" :disabled="!service_list.happyBirthday.length" @click="toHeartService(5)">
                                提醒
                            </el-button>

                        </div>
                        <div class="swiper-content-container margin-top-xs" v-if="service_list.happyBirthday.length">
                            <div class="swiper-button-prev swiper-button-prev5"></div>
                            <swiper
                                ref="swiper1"
                                :options="swiperOption5"
                                :pagination="{ clickable: true }"
                                navigation>
                                <swiper-slide v-for="(item,index) in service_list.happyBirthday" :key="index">
                                    <div class="name" @click="toMemberDetail(item)">
                                        {{ item.name }}
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-button-next swiper-button-next5"></div>
                        </div>
                        <div class="no-data margin-top-xs flex align-center justify-center" v-else>本周无会员过生日</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex margin-top-xs flex-sub">
            <div class="todo-container flex-shrink">
                <div class="classify-title">待办提醒</div>
                <div class="todo-total flex align-center justify-center">近一个月待办<span>{{ all_remind_list.length }}</span></div>
                <div class="menu-container flex align-center margin-tb-xs">
                    <div class="menu_item flex align-center justify-center" :class="{active:item.type === curTab}"
                         v-for="(item,index) in menus" :key="index" @click="changeTab(item,index)">
                        <div>{{ item.title }}</div>
                        <div class="span margin-left-xs">{{ item.count }}</div>
                    </div>
                </div>
                <div class="todo-list flex flex-direction margin-top-xs">
                    <div class="todo_item  flex flex-direction padding-top-sm" v-for="(item,index) in remind_list" :key="index" @click="remindToApply(item)">
                        <div class="flex align-center justify-between">
                            <div class="classify flex align-center">
                                <i class="iconfont icon-tongzhi margin-right-xs"></i>{{ item.type | remindType }}
                            </div>
                            <div class="time">{{ item.add_time }}</div>
                        </div>
                        <div class="title-container flex align-center" v-if="item.type === 1">
                            <div class="title">{{ item.name }}</div>
                            <div class="title">{{ item.user_type === 1 ? '单位会员' : '个人会员' }}</div>
                            <div class="title">{{ item.phone }}</div>
                        </div>
                        <div class="title-container flex align-center" v-else-if="item.type === 4">
                            <div class="title">{{ item.order_number }}</div>
                            <div class="title">{{ item.invoice_name }}</div>
                            <div class="title">¥{{ item.total_price | formatPrice }}</div>
                        </div>
                        <div class="title-container flex align-center" v-else>
                            <div class="title">{{ item.title }}</div>
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="!remind_list.length"></el-empty>
                </div>
            </div>
            <div class="rank-container flex flex-direction margin-left-xs flex-sub">
                <div class="classify-title">会员活跃度<span class="text-org">TOP10</span></div>
                <el-table
                    class="rank-list"
                    :data="rank_list"
                    :row-class-name="tableRowClassName"
                    header-row-class-name="table-header"
                    :highlight-current-row="false"
                    style="width: 100%">
                    <el-table-column label="排名" width="60">
                        <template slot-scope="scope">
                            <img class="rank-icon" v-if="scope.$index < 3" :src="require(`@/assets/img/total/icon_rank_${scope.$index + 1}.png`)"/>
                            <div class="table-rank" v-else>
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="姓名">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="integral" label="积分" width="90">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.integral }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>

import {
    getCostTotal,
    getJobTotal,
    getRankListTotal,
    getRemindListTotal,
    getServiceListTotal,
    getServiceNumberTotal, getSonPower,
    getUserTotal
} from "@/api/organiz";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {remind_menus} from "@/utils/const";
import {isPower} from "@/utils/utils";

export default {
    name: "index",
    data() {
        return {
            powers:[],
            user_total: '',
            const_total: '',
            service_total: '',
            service_list:{
                usersRenew:[],
                thanksJoin:[],
                zhuHeRuHui:[],
                usersCheck:[],
                happyBirthday:[],
            },
            remind_list: [],
            all_remind_list: [],
            job_total: [],
            rank_list: [],
            loading: false,
            swiperOption1: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                autoplay: false
            },
            swiperOption2: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next2',
                    prevEl: '.swiper-button-prev2'
                },
                autoplay: false
            },
            swiperOption3: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next3',
                    prevEl: '.swiper-button-prev3'
                },
                autoplay: false
            },
            swiperOption4: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next4',
                    prevEl: '.swiper-button-prev4'
                },
                autoplay: false
            },
            swiperOption5: {
                slidesPerView: 4,
                loop: false,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next5',
                    prevEl: '.swiper-button-prev5'
                },
                autoplay: false
            },
            menus: remind_menus,
            curTab: 0
        }
    },
    created() {
        this.$emit('setIndex', [0], '首页')
        if (this.user.sid) this.getSonPower()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    methods: {
        //  页面加载时请求
        async getSonPower() {
            let _data = await getSonPower(this.user.sid)
            if (_data.data) {
                this.powers = _data.data.split(',')
            }
        },
        //  页面加载时请求
        async init() {
            this.loading = true
            let _data = await getUserTotal()
            this.user_total = _data.data
            _data = await getJobTotal()
            this.job_total = _data.data
            _data = await getCostTotal()
            this.const_total = _data.data
            _data = await getServiceNumberTotal()
            this.service_total = _data.data
            _data = await getServiceListTotal()
            this.service_list = _data.data
            _data = await getRemindListTotal()
            this.remind_list = _data.data
            this.all_remind_list = _data.data
            this.menus.map(menu=>{
                menu.count = _data.data.filter(item=>{ return menu.role.indexOf(item.type) !==-1}).length
            })
            _data = await getRankListTotal()
            this.rank_list = _data.data
            this.loading = false
        },
        changeTab(data,index){
            this.curTab = data.type
                this.remind_list = this.all_remind_list.filter(item=>{ return this.menus[index].role.indexOf(item.type) !==-1})
        },
        remindToApply(item){
            switch (Number(item.type)) {
                case 1:
                    if (this.power('3-1')) this.$router.push(`/organization/members/examInfo/${item.id}`)
                    break
                case 2:
                    if (this.power('1-0')) this.$router.push(`/organization/notice/adetail/${item.id}`)
                    break
                case 3:
                    if (this.power('5-1'))this.$router.push(`/organization/organ/dynamic/detail/${item.id}`)
                    break
                case 4:
                    if (this.power('4-0'))this.$router.push(`/organization/fee/cost?home=1`)
                    break
                case 5:
                    if (this.power('4-0'))this.$router.push(`/organization/fee/fcost?home=1`)
                    break
            }
        },
        power(type) {
            return isPower(this.powers, type)
        },
        toMemberDetail(item) {
            this.$router.push(`/organization/members/info/${item.user_id}/${item.user_type}`)
        },
        toHeartService(type) {
            if (type === 4) {
                this.$router.push(`/organization/members/exam`)
            } else {
                this.$router.push(`/organization/heart/${type}`)
            }
        },
        tableRowClassName({rowIndex}) {
            if (rowIndex % 2 === 0) {
                return 'white'
            } else {
                return 'blue-light'
            }
        },
    },
    filters: {
        color(val) {
            let _colors = ['', 'green', 'blue', 'dark-blue', 'purple']
            return _colors[Number(val) % 5]
        },
        remindType(val){
            switch (Number(val)) {
                case 1:
                    return '待审核会员'
                case 2:
                    return '待审核通知'
                case 3:
                    return '待审核动态'
                case 4:
                    return '待审核会费'
                case 5:
                    return '待审核分会会费'

            }
        },
        formatPrice(val){
            return val ? Number(val).toFixed(2) : '--'
        }
    }

}
</script>

<style lang="scss" scoped>

/deep/.el-loading-mask{
    background-color: rgba(0, 0, 0, 0.1);
}
.swiper-button-prev {
    left: -23px;
}

.swiper-button-next {
    right: -23px;
}

.swiper-button-prev:after, .swiper-button-next:after {
    color: #adb7bf;
    font-size: 16px;
}

.wrapper {
    --green: #09cf9f;
    --blue: #1a9fed;
    --dark-blue: #1053af;
    --purple: #6c12b1;
    background-color: #0a2240;

    .page-title_white {
        font-size: 22px;
        font-weight: 600;
        color: #ffffff;
    }

    .classify-title {
        font-size: 16px;
        font-weight: 600;
        color: #0a2240;
    }

    .rank-container {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;

        .rank-icon {
            width: 19px;
        }

        .table-rank {
            font-size: 12px;
            font-weight: bold;
            color: #0a2240;
        }

        .table-name {
            font-size: 14px;
            color: #0a2240;
        }
    }

    .todo-container {
        width: 665px;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        position: relative;

        .todo-list {
            height: 480px;
            overflow: auto;
            border-top: 1px solid #f0f0f0;

            &::-webkit-scrollbar {
                width: 6px;
                height: 10px;
                background-color: transparent;
            }
            &::-webkit-scrollbar-track{
                -webkit-box-shadow : inset 0 0 0px rgba(0 ,0 ,0,0);
                border-radius : 3px ;
                background-color:#ffffff ;
            }
            &::-webkit-scrollbar-thumb{
                -webkit-box-shadow : inset 0 0 0px rgba(0 ,0 ,0,0);
                border-radius : 3px ;
                background-color:#0a2240 ;
            }

            .todo_item {
                cursor: pointer;
                .classify {
                    font-size: 12px;
                    color: #1559b5;
                }

                .time {
                    font-size: 12px;
                    color: #7485a1;
                }
            }

            .title-container {
                margin-top: 12px;
                margin-left: 28px;
                border-bottom:  1px solid #eeeeee;
                padding-bottom: 20px;
                .title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #0a2240;
                    padding-right: 10px;
                }

                .title + .title {
                    border-left: 1px solid #bdc5ce;
                    padding-left: 10px;
                }
            }
        }

        .todo-total {
            position: absolute;
            right: 0;
            top: 0;
            width: 170px;
            height: 36px;

            background-image: linear-gradient(169deg, #04459d 0%, #236aca 100%), linear-gradient(#f6fafe, #f6fafe);
            background-blend-mode: normal, normal;
            border-radius: 0px 10px 0px 10px;
            font-size: 14px;
            color: #ffffff;

            span {
                font-weight: 600;
                font-size: 20px;
                margin-left: 20px;
            }
        }

        .menu-container {
            background-color: #f8f8f8;
            border-radius: 5px;

            .menu_item {
                height: 30px;
                font-size: 14px;
                color: #7485a1;
                padding: 0 10px;
                text-align: center;
                cursor: pointer;
                flex-shrink: 0;
                flex-grow: 1;

                .span {
                    font-weight: 600;
                }

                &.active {
                    border-radius: 5px;
                    background-color: #1559b5;
                    color: #FFFFFF;
                    position: relative;

                    &:before {
                        position: absolute;
                        bottom: -8px;
                        border-left: 8px solid transparent;
                        border-top: 8px solid #1559b5;
                        border-right: 8px solid transparent;
                        left: 50%;
                        transform: translateX(-50%);
                        content: '';
                    }
                }
            }

            .menu_item + .menu_item {
                border-left: 1px solid #ffffff;
            }
        }
    }

    .service-container {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 12px 20px;

        .service_item {
            border-bottom: 1px solid #e6edf4;
            padding: 10px 0;

            .icon {
                width: 14px;
                height: 14px;
            }

            .title {
                font-size: 14px;
                font-weight: 600;
                color: #0a2240;
                margin-left: 3px;
            }

            .name {
                width: 62px;
                height: 32px;
                line-height: 32px;
                background-color: #f6fafe;
                border-radius: 10px;
                font-size: 14px;
                color: #0a2240;
                text-align: center;
                cursor: pointer;
            }

            .no-data {
                font-size: 14px;
                color: #999999;
                height: 30px;
            }

            .swiper-content-container {
                position: relative;
            }

            .swiper-container {
                width: 265px;
            }

            .operate {
                width: 62px;
                height: 25px;
                background-color: #ff9600;
                border-radius: 13px;
                font-size: 14px;
                line-height: 25px;
                text-align: center;
                color: #ffffff;
                padding: 0;
                border: none;

                &.is-disabled {
                    background-color: #e9e9e9 !important;
                    color: #adadad;
                }

                &.green {
                    background-color: var(--green);
                }

                &.blue {
                    background-color: var(--blue);
                }

                &.dark-blue {
                    background-color: var(--dark-blue);
                }

                &.purple {
                    background-color: var(--purple);
                }
            }
        }
    }

    .service-total-container {
        height: 123px;
        background-color: #ecf6ff;
        border-radius: 10px;
        background-image: linear-gradient(180deg, #ecf6ff 0%, #ecf6ff 30%, #ffffff 100%);

        .service-total_item {
            .title {
                font-size: 14px;
                color: #0a2240;
            }

            .number {
                font-size: 24px;
                font-weight: 600;
                color: #ff9600;
                margin: 10px 0;
            }

            .up-tag {
                font-size: 10px;
                color: #1b61be;
                padding: 2px 10px;
                background-color: #edf6ff;
                border-radius: 80px;
            }

            .up-number {
                font-size: 14px;
                font-weight: 600;
                color: #1b61be;
            }
        }

        .service-total_item + .service-total_item {
            position: relative;

            &:before {
                position: absolute;
                content: '';
                width: 1px;
                height: 67px;
                background-color: #e6edf4;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

    .total-container {
        width: 665px;
        height: 619px;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 25px 20px;

        .job-container {
            height: 90px;
            background-color: #f6fafe;
            border-radius: 10px;

            .job-total_item {
                .number {
                    font-size: 24px;
                    font-weight: 600;
                    color: #ff9600;

                    &.green {
                        color: var(--green);
                    }

                    &.blue {
                        color: var(--blue);
                    }

                    &.dark-blue {
                        color: var(--dark-blue);
                    }

                    &.purple {
                        color: var(--purple);
                    }
                }

                .label {
                    font-size: 12px;
                    color: #0a2240;
                    margin-top: 10px;
                }
            }

            .job-total_item + .job-total_item {
                border-left: 1px solid #e6edf4;
            }
        }

        .cost-total_item {
            width: 307px;
            height: 67px;
            border-radius: 10px;
            background-blend-mode: normal, normal;
            margin-top: 10px;
            padding: 0 25px;
            background-image: linear-gradient(90deg, #f6fafe 0%, #f6fafe 70%, #ffffff 100%);
            position: relative;

            &:after {
                position: absolute;
                content: '';
                width: 3px;
                height: 44px;
                border-radius: 2px;
                background-color: #ff9600;
                top: 50%;
                left: 6px;
                transform: translateY(-50%);
            }


            &.blue {
                &:after {
                    background-color: #2db7f4;
                }
            }

            &.green {
                &:after {
                    background-color: #19d4a0;
                }
            }

            &.dark-blue {
                &:after {
                    background-color: #1559b5;
                }
            }

            .number {
                font-size: 20px;
                font-weight: 600;
                color: #0f396e;
            }

            .label {
                font-size: 14px;
                color: #0a2240;
            }
        }

        .user-total_item {
            width: 307px;
            height: 93px;
            background-blend-mode: normal, normal;
            border-radius: 10px;
            margin-top: 10px;
            padding: 0 30px;
            background-image: linear-gradient(90deg, #ff8400 0%, #ffc000 100%),
            linear-gradient(#ff9600, #ff9600);

            &.blue {
                background-image: linear-gradient(90deg, #0080e3 0%, #4adbff 100%),
                linear-gradient(#ff9600, #ff9600);
            }

            &.green {
                background-image: linear-gradient(90deg, #00cb9e 0%, #8cffac 100%),
                linear-gradient(#ff9600, #ff9600);
            }

            &.dark-blue {
                background-image: linear-gradient(90deg, #04459d 0%, #0769ee 98%),
                linear-gradient(#ff9600, #ff9600);
            }

            position: relative;

            .bg {
                position: absolute;
                right: 0;
                bottom: 20px;
            }

            .number {
                font-size: 24px;
                font-weight: 600;
                color: #ffffff;
            }

            .label {
                font-size: 14px;
                color: #ffffff;
            }
        }
    }
}
</style>
